import React from 'react';
import DepartmentIndex from './department/Index'
import PrivilegeIndex from './priveleges/Index'
import PersonalQualityIndex from './personalQuality/Index'
import {useParams} from "react-router-dom";

const AdminPage = () => {
  const { id } = useParams();
  return (
    <div>

      {id === "department" && <DepartmentIndex />}
      {id === "privilege" && <PrivilegeIndex />}
      {id === "personal-quality" && <PersonalQualityIndex />}
    </div>
  );
};

export default AdminPage;